(function($j) {
    $j(function() {
        var loginForm = $j('#caSignInLoginForm');
        var loginButton = $j('#loginButton');
        var requiredMsg = 'This is a required field.';

        if (!loginForm.length) return; // for sign-in pages without this form
        loginForm.validateForm({
            rules: {
                login: {
                    required: true
                },
                password: {
                    required: true
                }
            },
            messages: {
                login: requiredMsg,
                password: requiredMsg
            },
            submitHandler: function() {
                if (loginForm.data('caUi-globalError')) {
                    loginForm.globalError('destroy');
                }

                loginButton
                    .buttonState()
                    .buttonState('loading');

                $j.post(
                    '/login/login', 
                    {
                        email: $j('#login').val(),
                        password: $j('#password').val(),
                        login_token: $j('#login_token').val()
                    }
                )
                .done(function(data) {
                    if (data.isValid && data.isLoggedIn) {
                        location.reload();
                    } else {
                        loginButton.buttonState('default');

                        if (data.messages && data.messages.length) {
                            var message = '';
                            data.messages.forEach(function(msg) {
                                message += msg + '<br />';
                            });

                            loginForm.globalError({
                                errorMessage: message
                            });
                        } else {
                            loginForm.globalError();
                        }
                    }
                })
                .fail(function() {
                    loginButton.buttonState('default');
                    loginForm.globalError();
                });
            }
        });
    });
})(jQuery);
